import React, { memo, useState } from 'react';

const Navbar = memo(() => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleNavClick = (targetId) => {
    closeMobileMenu();
    setTimeout(() => {
      if (targetId === '/') {
        window.location.hash = '#/';
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }, 100);
  };

  return (
    <nav className="bg-gradient-to-br from-primary-800 via-primary-900 to-primary-950 shadow-lg fixed w-full top-0 z-50" style={{ willChange: 'transform' }}>
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14 md:h-16">
          {/* Logo */}
          <a href="/" className="flex-shrink-0 flex items-center gap-2 md:gap-3 hover:opacity-80 transition-opacity min-w-0 flex-1 md:flex-initial">
            <img 
              src="/logo.png" 
              alt="Shravi Finance Logo" 
              className="h-8 md:h-10 w-auto flex-shrink-0"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <h1 className="text-sm sm:text-base md:text-xl lg:text-2xl font-bold text-white truncate">Shravi Financial Services</h1>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              <a 
                href="#/" 
                onClick={(e) => {
                  e.preventDefault();
                  window.location.hash = '#/';
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="navbar-link text-white hover:text-yellow-400 px-2 py-2 text-sm font-medium relative transition-colors"
              >
                Home
              </a>
              <a 
                href="#services" 
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.getElementById('services');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
                className="navbar-link text-white hover:text-yellow-400 px-2 py-2 text-sm font-medium relative transition-colors"
              >
                Services
              </a>
              <a 
                href="#about" 
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.getElementById('about');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
                className="navbar-link text-white hover:text-yellow-400 px-2 py-2 text-sm font-medium relative transition-colors"
              >
                About
              </a>
              <a 
                href="#apply" 
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.getElementById('apply');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
                className="navbar-link text-white hover:text-yellow-400 px-2 py-2 text-sm font-medium relative transition-colors"
              >
                Contact
              </a>
              <a 
                href="#contact" 
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.getElementById('contact');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
                className="navbar-link text-white hover:text-yellow-400 px-2 py-2 text-sm font-medium relative transition-colors"
              >
                Legal & Compliance
              </a>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex-shrink-0 ml-2">
            <button 
              onClick={toggleMobileMenu}
              className="text-white hover:text-white/80 focus:outline-none p-1"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile menu dropdown */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-white/20">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a
                href="#/"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('/');
                }}
                className="block px-3 py-2 text-base font-medium text-white hover:text-yellow-400 hover:bg-white/10 rounded-md transition-colors"
              >
                Home
              </a>
              <a
                href="#services"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('services');
                }}
                className="block px-3 py-2 text-base font-medium text-white hover:text-yellow-400 hover:bg-white/10 rounded-md transition-colors"
              >
                Services
              </a>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('about');
                }}
                className="block px-3 py-2 text-base font-medium text-white hover:text-yellow-400 hover:bg-white/10 rounded-md transition-colors"
              >
                About
              </a>
              <a
                href="#apply"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('apply');
                }}
                className="block px-3 py-2 text-base font-medium text-white hover:text-yellow-400 hover:bg-white/10 rounded-md transition-colors"
              >
                Contact
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('contact');
                }}
                className="block px-3 py-2 text-base font-medium text-white hover:text-yellow-400 hover:bg-white/10 rounded-md transition-colors"
              >
                Legal & Compliance
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
});

Navbar.displayName = 'Navbar';

export default Navbar;

